/** Pretty-print a tool input/output for the collapsible payload block. */
export function formatPayload(value: unknown): string {
  if (value === null || value === undefined) return 'null'
  if (typeof value === 'string') return value
  try {
    return decodeJsonStringEscapes(JSON.stringify(value, null, 2))
  } catch {
    return String(value)
  }
}

/**
 * JSON.stringify always turns real newlines/tabs inside strings into `\n`/`\t`.
 * Expand those two escapes in the pretty-printed payload so a spreadsheet or
 * markdown body is readable in the tool-trace <pre> instead of one escaped line.
 * Other JSON escapes (`\\`, `\"`, unicode) stay encoded.
 */
export function decodeJsonStringEscapes(json: string): string {
  return json.replace(/"((?:\\.|[^"\\])*)"/g, (match, inner: string) => {
    if (!inner.includes('\\n') && !inner.includes('\\t') && !inner.includes('\\r')) {
      return match
    }
    const decoded = inner.replace(/\\n/g, '\n').replace(/\\t/g, '\t').replace(/\\r/g, '\r')
    return `"${decoded}"`
  })
}
